import {getLocalizationBasedOnLang} from '../../data/models/User/UserInfo';

const english = {
  CourseEditRootCourse: 'Course',
  GeneralName: 'Course name',
  GeneralDescription: 'Course description',
  GeneralSaveButton: 'Save',
  GeneralCancelButton: 'Cancel',
  PosterHeading: 'Course poster',
  DescriptionPlaceholder: 'Enter course description here',
  changesSaved: 'Changes saved',
  courseEdited:
    'Your changes have been saved as a draft. To make these updates visible to learners, please republish the course.',
  imagePlaceholder: 'Select image',
  republishTooltip: 'Republish the course to make changes go live.',
  courseNotPublished: 'This course is not published',
  publishCourse: 'Publish course',
  subjectSelectTitle: 'Course category',
  subjectSelectPlaceholder: 'Select a category for this course',
};

const welsh = {
  CourseEditRootCourse: 'Cwrs',
  GeneralName: "Enw'r cwrs",
  GeneralDescription: "Disgrifiad o'r cwrs",
  GeneralSaveButton: 'Cadw',
  GeneralCancelButton: 'Canslo',
  PosterHeading: 'Poster y cwrs',
  DescriptionPlaceholder: 'Nodwch ddisgrifiad y cwrs yma',
  changesSaved: "Newidiadau Wedi'u cadw",
  imagePlaceholder: 'Dewis delwedd',
  republishTooltip: "Ailgyhoeddi'r cwrs i wneud i'r newidiadau fynd yn fyw",
  courseNotPublished: "Nid yw'r cwrs wedi'i gyhoeddi",
  publishCourse: "Cyhoeddi'r cwrs",
  subjectSelectTitle: "Categori'r cwrs",
  subjectSelectPlaceholder: 'Dewiswch gategori ar gyfer y cwrs hwn',
};

export const courseEditText: any = getLocalizationBasedOnLang(english, welsh);
